"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buttonDarkTheme = void 0;
var tokens_1 = __importDefault(require("../color/tokens"));
var tokens_2 = require("../layout/tokens");
exports.buttonDarkTheme = {
    primary: {
        "default": {
            backgroundColor: tokens_1["default"].neutralDark100,
            borderColor: tokens_1["default"].neutralDark100,
            textColor: tokens_1["default"].glassDark900,
            hover: {
                backgroundColor: tokens_1["default"].neutralDark400
            },
            active: {
                backgroundColor: tokens_1["default"].neutralDark400
            }
        },
        disabled: {
            backgroundColor: tokens_1["default"].neutralDark700,
            borderColor: tokens_1["default"].neutralDark700,
            textColor: tokens_1["default"].glassLight700,
            hover: {
                backgroundColor: tokens_1["default"].neutralDark400
            }
        },
        onDark: {
            "default": {
                backgroundColor: tokens_1["default"].neutralDark100,
                borderColor: tokens_1["default"].neutralDark100,
                textColor: tokens_1["default"].glassDark900,
                hover: {
                    backgroundColor: tokens_1["default"].neutralDark400
                },
                active: {
                    backgroundColor: tokens_1["default"].neutralDark400
                }
            },
            disabled: {
                backgroundColor: tokens_1["default"].neutralDark700,
                borderColor: tokens_1["default"].neutralDark700,
                textColor: tokens_1["default"].glassLight700,
                hover: {
                    backgroundColor: tokens_1["default"].neutralDark400
                }
            }
        },
        danger: {
            "default": {
                borderColor: tokens_1["default"].sentimentRed300,
                backgroundColor: tokens_1["default"].sentimentRed200,
                textColor: tokens_1["default"].white,
                hover: {
                    backgroundColor: tokens_1["default"].yellow1
                }
            },
            disabled: {
                borderColor: tokens_1["default"].glassLight500,
                backgroundColor: tokens_1["default"].transparent,
                textColor: tokens_1["default"].glassLight500,
                hover: {
                    backgroundColor: tokens_1["default"].transparent
                }
            }
        }
    },
    secondary: {
        "default": {
            backgroundColor: tokens_1["default"].transparent,
            borderColor: tokens_1["default"].glassLight900,
            textColor: tokens_1["default"].glassLight900,
            hover: {
                backgroundColor: tokens_1["default"].glassLight100
            },
            active: {
                backgroundColor: tokens_1["default"].glassLight200
            }
        },
        disabled: {
            backgroundColor: tokens_1["default"].transparent,
            borderColor: tokens_1["default"].glassLight300,
            textColor: tokens_1["default"].glassLight600,
            hover: {
                backgroundColor: tokens_1["default"].transparent
            }
        },
        onDark: {
            "default": {
                borderColor: tokens_1["default"].glassLight900,
                backgroundColor: tokens_1["default"].glassLight300,
                textColor: tokens_1["default"].glassLight900,
                hover: {
                    backgroundColor: tokens_1["default"].glassLight200
                },
                active: {
                    backgroundColor: tokens_1["default"].glassLight300
                }
            },
            disabled: {
                borderColor: tokens_1["default"].glassLight500,
                backgroundColor: tokens_1["default"].transparent,
                textColor: tokens_1["default"].glassLight500,
                hover: {
                    backgroundColor: tokens_1["default"].transparent
                }
            }
        },
        danger: {
            "default": {
                borderColor: tokens_1["default"].glassDark900,
                backgroundColor: tokens_1["default"].sentimentRed200,
                textColor: tokens_1["default"].white,
                hover: {
                    backgroundColor: tokens_1["default"].yellow1
                }
            },
            disabled: {
                borderColor: tokens_1["default"].glassLight500,
                backgroundColor: tokens_1["default"].transparent,
                textColor: tokens_1["default"].glassLight500,
                hover: {
                    backgroundColor: tokens_1["default"].transparent
                }
            }
        }
    },
    text: {
        "default": {
            backgroundColor: tokens_1["default"].transparent,
            borderColor: tokens_1["default"].transparent,
            textColor: tokens_1["default"].glassLight900
        },
        destructive: {
            backgroundColor: tokens_1["default"].transparent,
            borderColor: tokens_1["default"].transparent,
            textColor: tokens_1["default"].redish
        }
    },
    borderFocusColor: tokens_1["default"].glassLight900,
    borderRadius: {
        "default": tokens_2.BorderRadii.radius24,
        rounded: tokens_2.BorderRadii.radius24
    },
    borderWidth: 1
};
